import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export let state = {
  loggedIn: false,
  user: null,
};
const userInfo = localStorage.getItem('userInfo');
const accessToken = localStorage.getItem('accessToken');

if (userInfo) {
  state.user = JSON.parse(userInfo);
  state.accessToken = accessToken;
  if (accessToken) {
    state.loggedIn = true;
  }
}
const namespaced = false;

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
